import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import { FeatureRoute } from "../components/FeatureGate";
import Dashboard from "../pages/Dashboard/Index";
import InvestDashboard from "../pages/Invest/InvestDashboard";
import InvestProductDashboard from "../pages/Invest/InvestProductDash";
import DigitalWallet from "../pages/Trading/digitalWallet";
import AssetDashboard from "../pages/Trading/AssetDashboard";
import TwoFA from "../pages/Trading/twoFA";
import Index from "../pages/Onboarding/Index";
import SignUp from "../pages/Onboarding/SignUp";
import SignIn from "../pages/Onboarding/SignIn";
import SettingsIndex from "../pages/Settings/SettingsIndex";
import SettingsProfile from "../pages/Settings/SettingsProfile";
import SettingsWallet from "../pages/Settings/SettingsWallet";
import SettingsPrefer from "../pages/Settings/SettingsPreferences";
import SettingsNotif from "../pages/Settings/SettingsNotifications";
import SettingsAbout from "../pages/Settings/SettingsAbout";
import SettingsPriv from "../pages/Settings/about/PrivacyPolicy";
import SettingsTerms from "../pages/Settings/about/TermsOfService";
import SettingsPrice from "../pages/Settings/SettingsPriceAlert";
import SettingsCorp from "../pages/Settings/SettingsCorporate";
import SettingsBroker from "../pages/Settings/SettingsBroker";
import SettingsDonation from "../pages/Settings/SettingsDonation";
import SettingsMakeDonation from "../pages/Settings/SettingsMakeDonation";
import SettingsDonationsView from "../pages/Settings/SettingsDonationsView";
import SettingsAddress from "../pages/Settings/SettingsAddress";
import ForexDashboard from "../pages/Forex/ForexDashboard";
import SettingsInvite from "../pages/Settings/SettingsInvite";
import SettingsInvest from "../pages/Settings/SettingsInvest";
import Settings2FA from "../pages/Settings/Settings2FA";
import SettingsSecurity from "../pages/Settings/SettingsSecurity";
import SettingsSubAccounts from "../pages/Settings/SettingsSubAccounts";
import SupportIndex from "../pages/Support/SupportIndex";
import SupportFaq from "../pages/Support/SupportFaq";
import SupportEmail from "../pages/Support/SupportEmail";
import SupportWhatsapp from "../pages/Support/SupportWhatsapp";
import SupportChat from "../pages/Support/SupportChat";
import NotificationsPage from "../pages/Notifications/Index";
import Veriff from "../pages/Onboarding/Verification";
import CancelEmail from "../pages/Emails/EmailUnsubscribe";
import OnboardingPrivate from "./OnboardingPrivate";
import FicaDocuments from "../pages/Onboarding/FicaDocuments";
import Unauthorized from "../pages/Unauthorized";
import Finish from "../pages/Onboarding/Finish";
import ConfirmationPayDetails from "../components/confirmDetails";
import AccountDeactivate from "../pages/Account/AccountDeactivate";
import StackMore from "../pages/StackMore";
import AutostackDashboard from "../pages/AutostackDashboard";
import AutostackCreate from "../pages/Autostack";
import SingleAutoStack from "../pages/SingleAutoStack";
import Register from "../pages/Onboarding/Register";
import CompleteProfile from "../pages/Onboarding/CompleteProfile";
import EmailVerify from "../pages/Onboarding/EmailVerify";
import Welcome from "../pages/Onboarding/Welcome";
import AutostackOverall from "../pages/AutostackOverall";
import NotFound from "../pages/NotFound";
import EditAutoStack from "../pages/EditAutoStack";
import Login from "../pages/Onboarding/Login";
import ForgetEmail from "../pages/Onboarding/Forget";
import LoginTwoFA from "../pages/Onboarding/LoginTwoFA";
import BlockedAccount from "../pages/Onboarding/BlockedAccount";
import TradingLayout from "./TradingLayout";

const Root = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />

      <Route
        path="/autostack"
        element={
          <PrivateRoute>
            <FeatureRoute flag="autostack">
              <AutostackDashboard />
            </FeatureRoute>
          </PrivateRoute>
        }
      />

      <Route
        path="/autostack/create"
        element={
          <PrivateRoute>
            <FeatureRoute flag="autostack">
              <AutostackCreate />
            </FeatureRoute>
          </PrivateRoute>
        }
      />

      <Route
        path="/autostack/:stackId"
        element={
          <PrivateRoute>
            <FeatureRoute flag="autostack">
              <SingleAutoStack />
            </FeatureRoute>
          </PrivateRoute>
        }
      />

      <Route
        path="/autostack/edit/:stackId"
        element={
          <PrivateRoute>
            <FeatureRoute flag="autostack">
              <EditAutoStack />
            </FeatureRoute>
          </PrivateRoute>
        }
      />

      <Route
        path="/autostack/overall"
        element={
          <PrivateRoute>
            <FeatureRoute flag="autostack">
              <AutostackOverall />
            </FeatureRoute>
          </PrivateRoute>
        }
      />

      <Route
        path="/autostack/stackmore/:stackId"
        element={
          <PrivateRoute>
            <FeatureRoute flag="autostack">
              <StackMore />
            </FeatureRoute>
          </PrivateRoute>
        }
      />

      <Route
        path="/trading/asset-dashboard"
        element={
          <PrivateRoute>
            <TradingLayout>
              <AssetDashboard />
            </TradingLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/trading/digitalWallet"
        element={
          <PrivateRoute>
            <TradingLayout>
              <DigitalWallet />
            </TradingLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/trading/twoFA"
        element={
          <PrivateRoute>
            <TradingLayout>
              <TwoFA />
            </TradingLayout>
          </PrivateRoute>
        }
      />

      {/* <Route
          path="/onboarding/verify-email"
          element={<VerifyEmail />}
          // element={
          //     <PrivateRoute>
          //         <VerifyEmail />
          //     </PrivateRoute>
          // }
        /> */}
      <Route
        path="onboarding/verify"
        //element={<Veriff />}
        element={
          <PrivateRoute>
            <Veriff />
          </PrivateRoute>
        }
      />
      {/* <Route
                path="/onboarding/verifying"
                element={<Verifying />}
                // element={
                //     <PrivateRoute>
                //         <Verifying />
                //     </PrivateRoute>
                // }
            /> 
        */}
      <Route
        path="/onboarding/index"
        //element={<Index />}
        element={<Index />}
      />
      <Route
        path="/onboarding/ficadocuments"
        //element={<Index />}
        element={<FicaDocuments />}
      />
      <Route
        path="/onboarding/finish"
        //element={<Veriff />}
        element={
          <PrivateRoute>
            <Finish />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings"
        element={<Navigate to="/settings/index" replace />}
      />
      <Route
        path="/settings/index"
        element={
          <PrivateRoute>
            <SettingsIndex />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/profile"
        element={
          <PrivateRoute>
            <SettingsProfile />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/two-factor-auth"
        element={
          <PrivateRoute>
            <Settings2FA />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/wallet"
        element={
          <PrivateRoute>
            <SettingsWallet />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/preferences"
        element={
          <PrivateRoute>
            <SettingsPrefer />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/notifications"
        element={
          <PrivateRoute>
            <SettingsNotif />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/about"
        element={
          <PrivateRoute>
            <SettingsAbout />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/about/privacy"
        element={
          <PrivateRoute>
            <SettingsPriv />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/about/terms"
        element={
          <PrivateRoute>
            <SettingsTerms />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/price-alerts"
        element={
          <PrivateRoute>
            <SettingsPrice />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/corporate-account"
        element={
          <PrivateRoute>
            <SettingsCorp />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/become-a-broker"
        element={
          <PrivateRoute>
            <SettingsBroker />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/donations"
        element={
          <PrivateRoute>
            <SettingsDonation />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/invite-to-80eight"
        element={
          <PrivateRoute>
            <SettingsInvite />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/address-book"
        element={
          <Navigate
            to="/trading/digitalWallet"
            replace
            state={{ parentNavTab: "address-book" }}
          />
        }
      />
      <Route
        path="/settings/sub-accounts"
        element={
          <PrivateRoute>
            <SettingsSubAccounts />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/security"
        element={
          <PrivateRoute>
            <SettingsSecurity />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/invest"
        element={
          <PrivateRoute>
            <FeatureRoute flag="invest">
              <SettingsInvest />
            </FeatureRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/support/index"
        element={
          <PrivateRoute>
            <SupportIndex />
          </PrivateRoute>
        }
      />
      <Route
        path="/support/faqs"
        element={
          <PrivateRoute>
            <SupportFaq />
          </PrivateRoute>
        }
      />
      <Route
        path="/support/email"
        element={
          <PrivateRoute>
            <SupportEmail />
          </PrivateRoute>
        }
      />
      <Route
        path="/support/whatsapp"
        element={
          <PrivateRoute>
            <SupportWhatsapp />
          </PrivateRoute>
        }
      />
      <Route
        path="/support/chat"
        element={
          <PrivateRoute>
            <SupportChat />
          </PrivateRoute>
        }
      />
      <Route
        path="/emails/unsubscribe"
        element={
          <PrivateRoute>
            <CancelEmail />
          </PrivateRoute>
        }
      />
      <Route
        path="/notifications"
        element={
          <PrivateRoute>
            <NotificationsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/invest"
        element={
          <PrivateRoute>
            <FeatureRoute flag="invest">
              <InvestDashboard />
            </FeatureRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/invest/product"
        element={
          <PrivateRoute>
            <FeatureRoute flag="invest">
              <InvestProductDashboard />
            </FeatureRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/donations-view"
        element={
          <PrivateRoute>
            <SettingsDonationsView />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/make-donation"
        element={
          <PrivateRoute>
            <SettingsMakeDonation />
          </PrivateRoute>
        }
      />
      <Route
        path="/forex/forex-dashboard"
        element={
          <PrivateRoute>
            <FeatureRoute
              flag={["buyForex", "sellForex", "withdrawForex", "depositForex"]}
            >
              <ForexDashboard />
            </FeatureRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/account/account-deactivate"
        element={<AccountDeactivate />}
      />
      <Route path="/account/blocked" element={<BlockedAccount />} />
      <Route path="/login/2FA-auth" element={<LoginTwoFA />} />
      <Route path="onboarding/signup" element={<SignUp />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forget-email" element={<ForgetEmail />} />
      <Route
        path="/trading/confirmDetails"
        element={
          <TradingLayout>
            <ConfirmationPayDetails />
          </TradingLayout>
        }
      />
      <Route path="onboarding/signup" element={<SignUp />} />
      <Route path="/test/login" element={<SignIn />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/landing" element={<SignIn />} />
      <Route path="/signup" element={<Register />} />
      <Route
        path="/complete-profile"
        element={
          <OnboardingPrivate>
            <CompleteProfile />
          </OnboardingPrivate>
        }
      />
      <Route
        path="/onboarding/verify-email"
        element={
          <OnboardingPrivate>
            <EmailVerify />
          </OnboardingPrivate>
        }
      />
      <Route
        path="/onboarding/welcome"
        element={
          <OnboardingPrivate>
            <Welcome />
          </OnboardingPrivate>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Root;
